(function ($, DGS) {
  DGS.OnLoad.getInstance().register(function () {
    var MOBILE_BP = window.matchMedia('(max-width: 992px)');
    manageNavigation();
    function manageNavigation() {
      manageFirstLevel();
      manageSecondLevel();
    }
    function manageFirstLevel() {
      highlightActiveLinkInFirstLevel();
    }
    function manageSecondLevel() {
      highlightActiveLinkInSecondLevel();
      buildSecondLevelContainer();
      buildThirdLevelContainer();
      if (!MOBILE_BP.matches) {
        fillSecondLevelContainer(getSecondLevel());
        checkIfThirdLevelExists();
        showThirdLevel();
      }
      manageMobileNav();
    }
    function highlightActiveLinkInFirstLevel() {
      var firstLevelLinks = $('.level1 > a');
      highlightActiveLink(firstLevelLinks);
    }
    function highlightActiveLinkInSecondLevel() {
      var secondLevelLinks = $('.level2 > a');
      highlightActiveLink(secondLevelLinks);
    }
    function buildSecondLevelContainer() {
      var firstLevelContainer = $('#header .two-section-grid > .component-content');
      var secondLevelContainer = $("<div class='sticky-navigation'><div class='sticky-navigation-inner'></div></div>");
      secondLevelContainer.insertAfter(firstLevelContainer);
    }
    function buildThirdLevelContainer() {
      var secondLevelContainer = $('.sticky-navigation');
      var thirdLevelContainer = $("<div class='sticky-navigation-level3'><div class='sticky-navigation-level3-inner'></div></div>");
      thirdLevelContainer.insertAfter(secondLevelContainer);
    }
    function fillSecondLevelContainer(el) {
      var thirdLevelContainer = $('.sticky-navigation-inner');
      var thirdLevel = el.siblings('ul').clone();
      thirdLevelContainer.html(thirdLevel);
    }
    function mobileAddClassNextLevel() {
      var firstLevelLInks = $('.active-mobile-nav .level1 > a');
      firstLevelLInks.each(function () {
        var secondLevel = $(this).siblings('ul');
        if (secondLevel.length > 0) {
          $(this).addClass('expandable');
        }
      });
    }
    function checkIfThirdLevelExists() {
      var secondLevelLInks = $('.sticky-navigation-inner .level2 > a');
      secondLevelLInks.each(function () {
        var thirdLevel = $(this).siblings('ul');
        if (thirdLevel.length > 0) {
          $(this).addClass('expandable');
        }
      });
    }
    function showThirdLevel() {
      var secondLevelLInks = $('.sticky-navigation-inner .level2 > a.expandable');
      secondLevelLInks.each(function () {
        var _this = this;
        $(this).on('click', function (e) {
          e.preventDefault();
          $('.sticky-navigation-inner .level2 > a.expandable').not($(_this)).removeClass('active');
          $(_this).toggleClass('active');
          if ($(_this).hasClass('active')) {
            fillThirdLevelContainer($(_this));
          } else {
            $('.sticky-navigation-level3-inner').html('');
          }
        });
      });
    }
    function manageMobileNav() {
      if (MOBILE_BP.matches) {
        buildMobileNavBtns();
        showMobileNavMenu();
        hideMobileNavMenu();
        mobileSearch();
      }
    }
    function highlightActiveLink(el) {
      el.each(function () {
        var href = $(this).attr('href');
        var pathname = window.location.pathname;
        if (pathname.indexOf(href) === 0 && href !== '/' || pathname === href) {
          $(this).addClass('is-current');
        }
      });
    }
    function fillThirdLevelContainer(el) {
      var thirdLevelContainer = $('.sticky-navigation-level3-inner');
      var thirdLevel = el.siblings('ul').clone();
      thirdLevelContainer.html(thirdLevel);
    }
    function getSecondLevel() {
      var firstLevelActive;
      firstLevelActive = $('.level1 > a.is-current');
      return firstLevelActive;
    }
    function buildMobileNavBtns() {
      buildMobileNavBurger();
      buildMobileNavCloseBtn();
      var closeBtn = getMobileNavCloseBtn();
      closeBtn.hide();
    }
    function showMobileNavMenu() {
      var burger = getMobileNavBurger();
      var closeBtn = getMobileNavCloseBtn();
      var navFirstLevel = getNavFirstLevel();
      burger.on('click', function () {
        navFirstLevel.addClass('active-mobile-nav');
        mobileAddClassNextLevel();
        manageFirstLevelMobile();
        burger.hide();
        closeBtn.show();
        hideScroll();
      });
    }
    function hideMobileNavMenu() {
      var burger = getMobileNavBurger();
      var closeBtn = getMobileNavCloseBtn();
      var navFirstLevel = getNavFirstLevel();
      closeBtn.on('click', function (e) {
        closeBtn.hide();
        burger.show();
        var secondLevelNav = $('.sticky-navigation');
        var third = $('.sticky-navigation-level3');
        secondLevelNav.removeClass('mobile');
        third.removeClass('mobile');
        navFirstLevel.removeClass('active-mobile-nav');
        showScroll();
      });
    }
    function mobileSearch() {
      var search = $('.component.search-field-spot');
      var searchMobileContainer = getNavFirstLevel();
      var searchWrapper = $('<li class="level1"></li>');
      searchMobileContainer.append(search);
      search.wrap(searchWrapper);
    }
    function buildMobileNavBurger() {
      var mobileNav = getMobileNav();
      var burger = '<div class="mobile-burger"><span class="mobile-burger-item"></span><span class="mobile-burger-item"></span><span class="mobile-burger-item"></span></div>';
      mobileNav.prepend(burger);
    }
    function buildMobileNavCloseBtn() {
      var closeBtn = getMobileNavCloseBtn();
      var closeBtnContainer = getMobileNav();
      addCloseBtn(closeBtn, closeBtnContainer);
    }
    function getMobileNavCloseBtn() {
      return $('.navigation .close-icon');
    }
    function getMobileNavBurger() {
      return $('.navigation .mobile-burger');
    }
    function getNavFirstLevel() {
      var navFirstLevel = $('.navigation .component-content > ul');
      return navFirstLevel;
    }
    function manageFirstLevelMobile() {
      var firstLevelLinks = $('.active-mobile-nav > .level1 > a.expandable');
      firstLevelLinks.each(function () {
        var _this2 = this;
        $(this).on('click', function (e) {
          e.preventDefault();
          firstLevelLinks.removeClass('active');
          $(_this2).addClass('active');
          fillSecondLevelContainer($(_this2));
          checkIfThirdLevelExists();
          var secondLevelContainer = $('.sticky-navigation');
          secondLevelContainer.addClass('mobile');
          buildBackBtnToMobileSecondLevelNav();
          dismantleSecondLevelNav();
          mangeSecondLevelMobile();
        });
      });
    }
    function hideScroll() {
      $('body').css('overflow', 'hidden');
    }
    function showScroll() {
      $('body').css('overflow', 'visible');
    }
    function getMobileNav() {
      var mobileNav = $('#header .navigation .mobile-nav');
      return mobileNav;
    }
    function buildBackBtnToMobileSecondLevelNav() {
      var BtnContainer = $('.mobile .sticky-navigation-inner');
      var btn = getBackBtnToSecondLevelNav();
      var btnText = 'Back';
      buildBackBtnToMobileNav(BtnContainer, btn, btnText, 2);
    }
    function dismantleSecondLevelNav() {
      var backBtn = getBackBtnToSecondLevelNav();
      var btnContainer = $('.sticky-navigation');
      backBtn.on('click', function () {
        btnContainer.removeClass('mobile');
      });
    }
    function mangeSecondLevelMobile() {
      var links = $('.sticky-navigation .level2 > a.expandable');
      links.each(function () {
        var _this3 = this;
        $(this).on('click', function (e) {
          e.preventDefault();
          var container = $('.sticky-navigation-level3');
          container.addClass('mobile');
          fillThirdLevelContainer($(_this3));
          buildBackBtnToMobileThirdLevelNav();
          dismantleThirdLevelNav();
        });
      });
    }
    function getBackBtnToSecondLevelNav() {
      var backBtn = $('.mobile .sticky-navigation-inner .level2.nav-back-btn');
      return backBtn;
    }
    function buildBackBtnToMobileNav(container, btn, btnText, navLevel) {
      var btnHTML = "<div class='level".concat(navLevel, " nav-back-btn'><p><span class='arrow-left-icon'></span>").concat(btnText, "</p></div>");
      if (checkIfElementExists(btn)) {
        btn.show();
      } else {
        container.prepend(btnHTML);
      }
    }
    function buildBackBtnToMobileThirdLevelNav() {
      var BtnContainer = $('.mobile > .sticky-navigation-level3-inner');
      var btn = getBackBtnToThirdLevelNav();
      var btnText = 'Back';
      buildBackBtnToMobileNav(BtnContainer, btn, btnText, 3);
    }
    function dismantleThirdLevelNav() {
      var backBtn = getBackBtnToThirdLevelNav();
      var btnContainer = $('.sticky-navigation-level3');
      backBtn.on('click', function () {
        btnContainer.removeClass('mobile');
      });
    }
    function getBackBtnToThirdLevelNav() {
      var backBtn = $('.mobile .sticky-navigation-level3-inner .level3.nav-back-btn');
      return backBtn;
    }
    function addCloseBtn(btn, btnContainer) {
      if (checkIfElementExists(btn)) {
        btn.show();
      } else {
        addIcon(btnContainer, 'close-icon');
      }
    }
    function checkIfElementExists(element) {
      var elementExists = element.length > 0;
      return elementExists;
    }
    function addIcon(el, iconClass) {
      el.prepend("<div class=\"".concat(iconClass, "\"></div>"));
    }
  });
})(jQuery, window.DGS);